module.exports = __webpack_public_path__ + "img/whiteBrandLogoDark.57bb6bff.png";